export default function isWebSocketSupported() {
  return "WebSocket" in window || "MozWebSocket" in window;
}
